import React, { useContext, useState } from 'react';
import { Container, Row, Col, Card, CardBody, CardTitle, CardText, Button, Modal, ModalHeader, ModalBody } from 'reactstrap';
import Slider from 'react-slick';
import { HomeContext } from '../../context/HomeContext';

const Testimonials = () => {
    const { testimonials } = useContext(HomeContext);
    const [modal, setModal] = useState(false);
    const [selectedTestimonial, setSelectedTestimonial] = useState(null);

    const toggleModal = (testimonial) => {
        setSelectedTestimonial(testimonial);
        setModal(!modal);
    };

    const settingsTesti = {
        dots: true,
        infinite: testimonials?.length > 3,
        speed: 500,
        slidesToShow: testimonials?.length > 3 ? 3 : testimonials?.length,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: testimonials?.length > 2 ? 2 : testimonials?.length,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: true
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: testimonials?.length > 1 ? 1 : testimonials?.length,
                    slidesToScroll: 1
                }
            }
        ]
    };

    return (
        <>
            <section className="testimonials">
                <Container>
                    <Row>
                        <Col className="text-center">
                            <h2 className="title">Testimonials</h2>
                        </Col>
                    </Row>
                </Container>
                <Container className="testimonials-container">
                    <Row className="m-0">
                        <Slider {...settingsTesti}>
                            {testimonials && testimonials.map((row, index) => (
                                <Col md={4} key={index} className="testimonial-col">
                                    <Card className="testimonial-card">
                                        <CardBody>
                                            <CardTitle tag="h5">{row.name}</CardTitle>
                                            <CardText>
                                                <div className="testimonial-desc">
                                                    {row.desc && row.desc.length > 100 ? (
                                                        <>
                                                            {row.desc.substring(0, 100)}...
                                                        </>
                                                    ) : row.desc}
                                                </div>
                                                <div className='text-center mt-2'>
                                                    <Button color="link" size="sm" className="p-0 ml-1" onClick={() => toggleModal(row)}>Read More</Button>
                                                </div>
                                            </CardText>
                                            <div className="testimonial-date">{row.desgn}</div>
                                        </CardBody>
                                    </Card>
                                </Col>
                            ))}
                        </Slider>
                    </Row>
                </Container>
            </section>

            {/* Modal for full testimonial */}
            <Modal isOpen={modal} toggle={() => toggleModal(null)} centered>
                <ModalHeader toggle={() => toggleModal(null)}>{selectedTestimonial?.name}</ModalHeader>
                <ModalBody>
                    <p>{selectedTestimonial?.desc}</p>
                    <p><strong>{selectedTestimonial?.desgn}</strong></p>
                </ModalBody>
            </Modal>
        </>
    );
};

export default Testimonials;
